import {IonIcon} from "react-ion-icon";

const ProjectInGrid = props => {

    const project = props.project
    const selectedProject = props.selectedProject
    const selectProject = props.selectProject

    const lastActivity = (project.LastActivity ? project.LastActivity.toLocaleDateString('cs-CZ') : "never")

    const minutes = (project.TotalActivity % 60).toString().padStart(2, '0')
    const hours = Math.floor(project.TotalActivity / 60)

    const TimeStr = (minutes === 0) ? hours + " h" : hours + ":" + minutes

    return(
        <>

            <div className="project-in-grid" onClick={() => selectProject(project)}>

                <h2>{project.Name}</h2>
                <div className="client-in-grid-info">Last activity: {lastActivity}</div>
                <div className="client-in-grid-info">Total activity: {TimeStr}</div>
                {/*<div className="client-in-grid-info">{project.Representative}</div>*/}
                {/*<div className="client-in-grid-info">{project.Phone}</div>*/}
                {selectedProject && (selectedProject.ID === project.ID) &&
                    <span className="project-selected-ico">
                        <IonIcon name="checkmark-done-outline"></IonIcon>
                    </span>
                }

            </div>

        </>
    )
}

export default ProjectInGrid